module.exports = "/assets/60228ffa5cfbcf7ab86ec870016b5b20.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/OM.png
// module id = 2809
// module chunks = 0